// Shader utility library

export const shaderUtils = {
    // Common vertex shader for fullscreen quad
    vertexShader: `
        varying vec2 vUv;
        
        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `
};
